// tslint:disable:no-console
import { startOfDay, startOfMonth, startOfWeek } from 'date-fns';
import { groupBy, sortBy } from 'lodash';
import { variables } from '../components/utils';
import { Measurement } from './helpers/measurement';
import { INote, ISubject, ITrackerWithNotes } from './helpers/types';
import { QualaRange } from './qualaRange';

export function logger(value: any) {
  console.log(value);
  return false;
}

export function arrayOfIds(arr: { id: string }[] = []): string[] {
  return arr.reduce((acc: string[], cur: any) => {
    acc.push(cur.id);
    return acc;
  }, []);
}

export function trackerInGroups(groupIds: string[], trackerId: string, ctx: any) {
  const inGroup: any[] = [];

  // Check each group for trackerId
  groupIds.forEach((groupId: any) => {
    const group = ctx.currentNotebook.groups.filter((g: any) => g.id === groupId)[0];
    const groupTrackerIds = arrayOfIds(group.trackers);
    if (groupTrackerIds.includes(trackerId)) {
      inGroup.push(group.name);
    }
  });

  // Return Toggle Text
  if (inGroup.length === 0) {
    return null;
  } else if (inGroup.length === 1) {
    return inGroup[0];
  } else {
    return `In ${inGroup.length} groups`;
  }
}

// TODO: fix the any
export function subjectInGroups(groupIds: string[], subjectId: string, notebookContext: any) {
  const inGroup: any[] = [];

  // Check each group for subjectId
  groupIds.forEach((groupId: any) => {
    const group = notebookContext.groups.filter((g: any) => g.id === groupId)[0];
    const groupSubjectIds = arrayOfIds(group.subjects);
    if (groupSubjectIds.includes(subjectId)) {
      inGroup.push(group.name);
    }
  });

  // Return Toggle Text
  if (inGroup.length === 0) {
    return null;
  } else if (inGroup.length === 1) {
    return inGroup[0];
  } else {
    return `In ${inGroup.length} groups`;
  }
}

export function isSmall() {
  return window.innerWidth < variables.medium;
}

export function dataForTrafficLightBar(
  groupedByDate: { [dateString: string]: Measurement[] },
  range: QualaRange
) {
  const red: IPercentageMeasurement[] = [];
  const yellow: IPercentageMeasurement[] = [];
  const green: IPercentageMeasurement[] = [];

  Object.keys(groupedByDate).forEach(dateString => {
    const measurements = groupedByDate[dateString];
    const measurementsByValue = groupBy(measurements, m => m.value);
    const count = measurements.length;

    const date: Date = snapTo(range, dateString);

    Object.keys(measurementsByValue).forEach(value => {
      const measurementCount = measurementsByValue[value].length;
      const percentage = Math.round((measurementCount / count) * 100);
      if (value === '0') {
        yellow.unshift({ date, value: percentage });
      }
      if (value === '1') {
        green.unshift({ date, value: percentage });
      }
      if (value === '-1') {
        red.unshift({ date, value: percentage });
      }
    });
  });

  return { red, yellow, green };
}

export function dataForBinaryBar(
  groupedByDate: { [dateString: string]: Measurement[] },
  range: QualaRange
) {
  const no: IPercentageMeasurement[] = [];
  const yes: IPercentageMeasurement[] = [];

  Object.keys(groupedByDate).forEach(dateString => {
    const measurements = groupedByDate[dateString];
    const measurementsByValue = groupBy(measurements, m => m.value);
    const count = measurements.length;

    const date: Date = snapTo(range, dateString);

    Object.keys(measurementsByValue).forEach((value: string) => {
      const measurementCount = measurementsByValue[value].length;
      const percentage = Math.round((measurementCount / count) * 100);
      if (value === '0') {
        no.unshift({ date, value: percentage });
      }
      if (value === '1') {
        yes.unshift({ date, value: percentage });
      }
    });
  });

  return { no, yes };
}

function snapTo(range: QualaRange, dateString: string) {
  let date: Date;
  if (range.groupBy === 'day') {
    date = startOfDay(new Date(dateString));
  } else if (range.groupBy === 'week') {
    date = startOfWeek(new Date(dateString));
  } else if (range.groupBy === 'month') {
    date = startOfMonth(new Date(dateString));
  } else {
    throw new Error('Unknown group type');
  }
  return date;
}

export function mostRecentNote(trackers: ITrackerWithNotes[]) {
  const notes = trackers.reduce((acc: INote[], cur: ITrackerWithNotes) => {
    if (cur.notes.length) {
      acc.push(...cur.notes);
    }
    return acc;
  }, []);

  const notesByDate = sortBy(notes, note => note.notedAt);
  return notesByDate[notes.length - 1];
}
